// extracted by css-extract-rspack-plugin
export default {"headerTwo":"DisableTwoFactorDevice_headerTwo__HhCcA","layoutContainer":"DisableTwoFactorDevice_layoutContainer__2wbKN"};